import React from 'react';
import { motion } from 'framer-motion';
import { FiAward, FiBriefcase, FiCpu } from 'react-icons/fi';
import profileImg from '../assets/Profile1.png';

export default function About() {
  const cards = [
    {
      icon: <FiAward className="w-5 h-5 text-[#4779c4]" />,
      title: 'Experience',
      subtitle: '1+ Years Working',
    },
    {
      icon: <FiBriefcase className="w-5 h-5 text-[#4779c4]" />,
      title: 'Completed',
      subtitle: '10+ Projects',
    },
    {
      icon: <FiCpu className="w-5 h-5 text-[#4779c4]" />,
      title: 'Skills',
      subtitle: '15+ Skills Learned',
    },
  ];

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-slate-400 text-sm tracking-widest uppercase mb-2">My Intro</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white font-['Lora']">
            About Me
          </h2>
          <div className="w-16 h-1 bg-[#4779c4] mx-auto rounded-full mt-4" />
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          
          {/* Left: Profile Image Container */}
          <div className="relative mx-auto w-full max-w-[380px] aspect-square rounded-[3rem] overflow-hidden bg-[#2c456b] shadow-2xl">
            <img 
              src={profileImg} 
              alt="Wishmitha Devinda" 
              className="w-full h-full object-cover object-center grayscale hover:grayscale-0 transition-all duration-700"
              onError={(e) => {
                e.target.src = "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?fit=crop&w=600&q=80";
              }}
            />
          </div>

          {/* Right: Info and Text in Frosted Matte Glass Container */}
          <div className="bg-[#2c456b]/35 backdrop-blur-2xl rounded-[2.5rem] border border-white/10 p-6 sm:p-8 shadow-2xl flex flex-col items-center lg:items-start text-center lg:text-left relative overflow-hidden">
            {/* Subtle inner accent glow */}
            <div className="absolute -top-20 -right-20 w-48 h-48 bg-[#4779c4]/15 rounded-full blur-[60px] pointer-events-none" />

            {/* Info Cards */}
            <div className="grid grid-cols-3 gap-3.5 w-full mb-6 relative z-10">
              {cards.map((card, i) => (
                <div 
                  key={i}
                  className="bg-[#1b2d48]/70 backdrop-blur-md p-3.5 rounded-2xl border border-white/10 flex flex-col items-center text-center hover:bg-[#4779c4]/20 transition-all duration-300 group shadow-md"
                >
                  <div className="mb-1.5 group-hover:scale-110 transition-transform duration-300">{card.icon}</div>
                  <h3 className="text-white text-xs sm:text-sm font-bold mb-0.5">{card.title}</h3>
                  <p className="text-slate-400 text-[9px] sm:text-[10px]">{card.subtitle}</p>
                </div>
              ))}
            </div>

            {/* Description */}
            <p className="text-slate-200 text-sm sm:text-base leading-relaxed font-['Lora'] mb-6 max-w-lg relative z-10">
              I’m Wishmitha Devinda, a Computer Science undergraduate passionate about web development and software engineering. I enjoy building clean, user-friendly applications and continuously improving my skills in frontend development, UI/UX, and modern technologies. Always eager to learn, create, and grow.
            </p>

            {/* Contact Button */}
            <a 
              href="#contact"
              className="px-9 py-3.5 bg-[#4779c4] text-white font-bold rounded-2xl hover:bg-[#3c649f] transition-all duration-300 shadow-lg shadow-[#4779c4]/30 inline-block relative z-10"
            >
              Contact Me
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}